import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

// const basePath = `${API_URLS.VEHICLE}/v1/fuel`;
const basePath = API_URLS.VEHICLE_V3;


async function create(payload) {
  try {
    let response = await api.post(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "fuelService.create");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.create");
    return null;
  }
}

async function update(payload) {
  try {
    let response = await api.put(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(response, "fuelService.update");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.update");
    return null;
  }
}

async function list() {
  
  try {
    let response = await api.get(`${basePath}/fuels`);
    let treated = errorHandling.handleResponse(response, "fuelService.create");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "fuelService.create");
    return null;
  }
}

export const fuelService = {
  create,
  update,
  list,
};
